const ErrorCodesFromApi = Object.freeze({
  AUTHENTICATION_ERROR: 'authentication_error',
  PERMISSION_DENIED: 'permission_denied',
  ACCESS_DENIED: 'access_denied',
  ACCOUNT_PAUSED: 'account_paused',
});

export default ErrorCodesFromApi;
